<!--
  Discount value cell (§4.6). `%` only — never `$`, list/unit/case price.
  Always a single line.
-->
<span class="pf-discount-value" [attr.aria-label]="ariaLabel">{{ format(tier1Value) }}</span>
